/*
 Created by CHT 2019/12/4 10:52
 日历（图表控件）
*/
import BaseChart from "../BaseChart"
import {CHART_CATEGORY__CHART, CHART_TYPE__CALENDAR, CHART_TYPE__FILTER_CONTROL} from "../types"
import {DASHBOARD_DATA_SOURCE_EXIST, SUCCESS} from "../../../src/store/types";
import {FORM_ITEM__DATE} from "../../RyForm/types";
import {getCurrentMonthFirstDay, getCurrentMonthLastDay} from "../../../assets/js/Untis";

class Calendar extends BaseChart {
  constructor() {
    super()

    this.w = 30
    this.h = 16
    // 最小宽
    this.minW = 30
    // 最小高
    this.minH = 16

    this.chartPropertiesHolder = {
      filter: {
        relation: "and",
        notJumpEmpty: 0, //是否不跳过空值过滤 0 跳过 1 不跳过
        conditionList: []
      },
      showAllFields: 1,
      showFieldIds: [],  // 显示字段
      dateLatitudeField: ""  // 时间字段的dataId
    }

    this.currentSelectMonth = [getCurrentMonthFirstDay(), getCurrentMonthLastDay()]
  }

  get title() {
    return this.chartName || Calendar._title
  }

  set title(content) {
    this.chartName = content
  }
}

Calendar._title = '日历'
Calendar.type = CHART_TYPE__CALENDAR

Calendar.prototype.chartCategory = CHART_CATEGORY__CHART
Calendar.prototype.chartType = Calendar.type

Calendar.prototype.getValue = function (opts = {}, filter, isSetting = false) {

  if (this.hidden) {
    // 图表不可见，不用请求数据
    return
  }
  if (!filter) {

    const chartCondition = []
    this.parent.children
      .filter(chart => chart.chartType === CHART_TYPE__FILTER_CONTROL)
      .forEach(filterControl => {
        const holder = filterControl.chartPropertiesHolder
        const filterConf = holder.chartFilterMap[this.chartId]

        if (filterConf && filterControl.value.method) {
          chartCondition.push({
            type: "",
            method: filterControl.value.method,
            value: filterControl.value.value,
            fieldId: filterConf.dataId,
            fixedValue: filterControl.value.fixedValue,
            extValue: filterControl.value.extValue
          })
        }
      })

    chartCondition.push({
      modify: 1, //0:数据筛选时不可修改条件，1:可修改
      type: FORM_ITEM__DATE,
      method: "range",
      fixedValue: 'fixed_value',
      value: this.currentSelectMonth,
      fieldId: this.chartPropertiesHolder.dateLatitudeField
    })

    filter = {
      relation: "and",
      notJumpEmpty: 0, //是否不跳过空值过滤 0 跳过 1 不跳过
      conditionList: chartCondition,
    }
  } else {
    filter.conditionList.push({
      modify: 1, //0:数据筛选时不可修改条件，1:可修改
      type: FORM_ITEM__DATE,
      method: "range",
      fixedValue: 'fixed_value',
      value: this.currentSelectMonth,
      fieldId: this.chartPropertiesHolder.dateLatitudeField
    })
  }
  console.log('filter', filter)

  const chart = Object.assign(this.getBase(), opts)

  return this.parent.chartDataPreviewFun({
    chartId: this.chartId,
    currentPage: -1,
    pageSize: -1,
    sort: {},
    filter,
    chart
  }).then(({status, resultObject, info}) => {

    if (status === SUCCESS) {
      if (isSetting) {
        return resultObject
      } else {
        this.value = resultObject
      }
    } else if (status === DASHBOARD_DATA_SOURCE_EXIST) {
      this.errorPrompt = '控件已删除'
    }
  }).catch(err => {
    console.error(err)
  }).finally(() => {
    this.isLoad = true
  })
}
export default Calendar
